import React from 'react'
import {
  RegisterItem,
  RegisterItemFlatPropertyData,
} from '@core/entities/register/RegisterItem'
import { RegisterItemContentVariant } from '@modules/registers/items/types'
import { RegisterItemPropertyStringValue } from '@modules/registers/propertyValue/RegisterItemPropertyStringValue'
import { RegisterItemPropertySelectValue } from '@modules/registers/propertyValue/RegisterItemPropertySelectValue'
import { RegisterItemPropertyDateValue } from '@modules/registers/propertyValue/RegisterItemPropertyDateValue'
import { RegisterItemPropertyNumberValue } from '@modules/registers/propertyValue/RegisterItemPropertyNumberValue'
import { RegisterItemPropertyUserValue } from '@modules/registers/propertyValue/RegisterItemPropertyUserValue'
import { RegisterItemPropertyDiagramValue } from '@modules/registers/propertyValue/RegisterItemPropertyDiagramValue'
import { RegisterItemPropertyInspectionValue } from '@modules/registers/propertyValue/RegisterItemPropertyInspectionValue'
import { RegisterItemPropertyTimeValue } from '@modules/registers/propertyValue/RegisterItemPropertyTimeValue'
import { RegisterItemPropertyPermitValue } from './RegisterItemPropertyPermitValue'
import { RegisterItemPropertyTaskValue } from './RegisterItemPropertyTaskValue'
import { RegisterItemPropertyChecklistValue } from './RegisterItemPropertyChecklistValue'
import { RegisterItemPropertyAttachmentValue } from './RegisterItemPropertyAttachmentValue'
import useFeatureFlags from '@core/providers/useFeatureFlags'
import { RegisterItemPropertyScheduleInspectionValue } from './RegisterItemPropertyScheduleInspectionValue'

type RegisterItemContentProps = {
  registerItemPropertyData: RegisterItemFlatPropertyData
  registerItem?: RegisterItem
  variant: RegisterItemContentVariant
  onChangeTab?: (tab: string) => void
}
export const RegisterItemPropertyValue: React.FC<RegisterItemContentProps> = ({
  registerItemPropertyData,
  registerItem,
  variant,
  onChangeTab,
}) => {
  const { flags } = useFeatureFlags(['web_register_schedule_inspections'])
  const enableScheduleInspections = flags.web_register_schedule_inspections
  switch (registerItemPropertyData?.type) {
    case 'STRING':
      return (
        <RegisterItemPropertyStringValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'SELECT':
      return (
        <RegisterItemPropertySelectValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'DATE':
      return (
        <RegisterItemPropertyDateValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'NUMBER':
      return (
        <RegisterItemPropertyNumberValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'USER':
      return (
        <RegisterItemPropertyUserValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'DIAGRAM':
      return (
        <RegisterItemPropertyDiagramValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'INSPECTION':
      if (enableScheduleInspections) {
        return (
          <RegisterItemPropertyScheduleInspectionValue
            registerItem={registerItem}
            onInspectionClick={() => onChangeTab?.('inspections')}
          />
        )
      }
      return (
        <RegisterItemPropertyInspectionValue
          registerItemPropertyData={registerItemPropertyData}
          registerItem={registerItem}
          variant={variant}
          onInspectionClick={() => onChangeTab?.('checklists')}
        />
      )
    case 'TIME':
      return (
        <RegisterItemPropertyTimeValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
        />
      )
    case 'PERMIT':
      return (
        <RegisterItemPropertyPermitValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
          statusCountArray={
            registerItem?.getActivePermitsStatusCountArray() ?? []
          }
          onPermitClick={() => onChangeTab?.('permits')}
        />
      )
    case 'TASK':
      return (
        <RegisterItemPropertyTaskValue
          registerItemPropertyData={registerItemPropertyData}
          variant={variant}
          statusCountArray={
            registerItem?.getActiveTasksStatusCountArray() ?? []
          }
          onTaskClick={() => onChangeTab?.('tasks')}
        />
      )
    case 'CHECKLIST':
      return (
        <RegisterItemPropertyChecklistValue
          registerItemPropertyData={registerItemPropertyData}
          statusCountArray={registerItem?.getChecklistsStatusCountArray() ?? []}
          onChecklistClick={() => onChangeTab?.('checklists')}
        />
      )
    case 'ATTACHMENT':
      return (
        <RegisterItemPropertyAttachmentValue
          registerItemPropertyData={registerItemPropertyData}
          onAttachmentClick={() => onChangeTab?.('attachments')}
        />
      )
    default:
      return <></>
  }
}
